import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import map from 'lodash/map'
import pick from 'lodash/pick'
import keys from 'lodash/keys'
import findKey from 'lodash/findKey'
import { withStyles } from '@material-ui/core/styles'
import { Validator } from 'react-vld'
import { validateNotNil } from 'utils/validation'
import Typography from '@material-ui/core/Typography'
import Input, { InputPropTypes } from 'atoms/Input'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

// Styles
const styles = theme => ({
  root: {
    position: 'relative',
    height: '2rem',
    display: 'inline-flex',
    alignItems: 'center',
  },
  rootWithError: {
    '& $value': {
      color: theme.palette.error.main,
    },
  },
  select: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
  },
  value: {
    position: 'relative',
    lineHeight: 'normal',
    flex: 1,
  },
  chevron: {
    position: 'relative',
    marginLeft: theme.spacing.unit / 2,
  },
})

@withStyles(styles)
class Select extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    items: PropTypes.any,
    getItemValue: PropTypes.func,
    renderItem: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    validation: PropTypes.object.isRequired,
    errorMessage: PropTypes.any,
    placeholder: PropTypes.any, // @todo Use this prop
  }

  static defaultProps = {
    getItemValue: item => item,
    renderItem: item => item,
    onChange: () => {},
    value: null,
    items: [],
  }

  valueToString = (value) => {
    try {
      return value.toString()
    } catch (e) {
      return ''
    }
  }

  handleChange = (ev) => {
    const { onChange, getItemValue, items, validation } = this.props
    const { value } = ev.target

    const selectedItemKey = findKey(
      items,
      (item, key) => {
        return this.valueToString(getItemValue(item, key)) === value
      }
    )

    const selectedItem = items[selectedItemKey] || null
    const selectedItemValue = selectedItem && getItemValue(selectedItem, selectedItemKey)

    // Reset validation
    if (validation) validation.reset({ updateComponent: false })

    onChange(ev, selectedItemValue, selectedItem)
  }

  renderOption = (item, key) => {
    const { renderItem, getItemValue } = this.props
    const value = getItemValue(item, key)
    return (
      <option key={value} value={this.valueToString(value)}>
        { renderItem(item, key) }
      </option>
    )
  }

  render() {
    const {
      classes, items, renderItem, value, getItemValue, placeholder,
      validation, errorMessage: errorMessageProp
    } = this.props
    const InputProps = pick(this.props, keys(InputPropTypes))
    const errorMessage = validation.isInvalid ? validation.error.message : errorMessageProp
    const selectedItemKey = findKey(items, (item, key) => getItemValue(item, key) === value)
    const selectedItem = items[selectedItemKey]
    const cx = classNames(classes.root, {
      [classes.rootWithError]: !!errorMessage
    })
    return (
      <Input {...InputProps} errorMessage={errorMessage}>
        { ({ id }) => (
          <div className={cx}>
            <Typography className={classes.value}>
              { selectedItem ? renderItem(selectedItem, selectedItemKey) : placeholder }
            </Typography>
            <KeyboardArrowDownIcon color="action" className={classes.chevron} />
            <select
              id={id}
              className={classes.select}
              value={this.valueToString(value)}
              onChange={this.handleChange}
            >
              { placeholder && <option value="">{ placeholder }</option> }
              { map(items, this.renderOption) }
            </select>
          </div>
        )}
      </Input>
    )
  }
}

export default class SelectValidator extends PureComponent { // eslint-disable-line
  static propTypes = {
    validation: PropTypes.object,
    required: PropTypes.bool,
    value: PropTypes.any,
  }

  validate = () => {
    const { required, value } = this.props
    if (required) validateNotNil(value, 'Required field')
  }

  render() {
    const { validation, required, ...rest } = this.props
    return (
      <Validator rule={this.validate}>
        { innerValidation => (
          <Select
            {...rest}
            validation={validation || innerValidation}
          />
        ) }
      </Validator>
    )
  }
}
